import { useTrackView } from 'src/app/shared/hooks/tracking';

import { Variant1 } from './components/Variant1';
import { Variant2 } from './components/Variant2';
import { Variant3 } from './components/Variant3';
import { Variant4 } from './components/Variant4';
import { Variant5 } from './components/Variant5';
import { Variant6 } from './components/Variant6';
import { Variant7 } from './components/Variant7';
import { Variant8 } from './components/Variant8';

type Props = {
	variant: string;
	onAccept: () => void;
	onDecline: () => void;
	onDeclineWithReason: () => void;
};

export const VariantWrapper: React.FC<Props> = ({ variant, ...props }) => {
	useTrackView('post_promote_membership_ask_modal_view', { context: 'wiki_membership_modal_experiment' });

	if (variant === 'variant_1') {
		return <Variant1 {...props} />;
	}
	if (variant === 'variant_2') {
		return <Variant2 {...props} />;
	}
	if (variant === 'variant_3') {
		return <Variant3 {...props} />;
	}
	if (variant === 'variant_4') {
		return <Variant4 {...props} />;
	}
	if (variant === 'variant_5') {
		return <Variant5 {...props} />;
	}
	if (variant === 'variant_6') {
		return <Variant6 {...props} />;
	}
	if (variant === 'variant_7') {
		return <Variant7 {...props} />;
	}
	if (variant === 'variant_8') {
		return <Variant8 {...props} />;
	}
	return null;
};
